/** User-supplied artwork; never redraw or recolor the brand assets. */
export function Brand({ className = "" }: { className?: string }) {
  return (
    <div className={`brand ${className}`.trim()}>
      <img
        className="brand-logo"
        src="/brand/ZentroTaxAILogo.png"
        alt="ZentroTaxAI — Taxes Made Intelligent"
        width={888}
        height={300}
        decoding="async"
      />
    </div>
  );
}
